import { useCallback, useState } from 'react';
import { useAppSelector } from 'hooks';

import { submitInteractiveEmailDeflectionFeedback } from 'actions/workflows/workflows';
import { selectConversationId } from 'reducers/workflows';
import { selectRawParams } from 'reducers/config';

const useSubmitInteractiveEmailDeflectionFeedback = ({
  isDeflected,
}: {
  isDeflected: boolean;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const conversationId = useAppSelector(selectConversationId);
  const token =
    useAppSelector(selectRawParams)?.['data-interactive-email-token'];

  const onSubmit = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await submitInteractiveEmailDeflectionFeedback({
        conversationId,
        isDeflected,
        token,
      });

      window.parent.location.href = data.redirect_url;
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }, [conversationId, isDeflected, token]);

  return { isLoading, onSubmit };
};

export default useSubmitInteractiveEmailDeflectionFeedback;
